<template>
  <div>
    <div class="notification is-warning">
      <span>Vous pouvez encore générer </span>
      <span>{{ 3 - answers.length }}&nbsp;</span>
      <span>réponse{{ (3 - answers.length) > 1 ? 's' : '' }}</span>
    </div>
    <div class="columns is-multiline">
      <div class="column is-12" style="padding-bottom: 0px;">
        <div class="block" v-if="generating">
          <span>En cours de génération (par l'assistant {{ this.selectedAssistant.name }})</span>
        </div>
        <div class="block notification is-danger" v-if="generation_error">
          <span>Erreur lors de la génération: {{ generation_error_message }}</span>
        </div>
        <div class="block">
          <button class="button btn btn-outline-primary is-fullwidth" v-if="!generating"
                  @click="generateAdditionalAnswer">
            Générer une autre réponse
          </button>
        </div>
      </div>
    </div>
    <!-- Modal Section -->
    <div class="modal" :class="{ 'is-active': showModal }">
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Générer une autre réponse</p>
          <button class="delete" @click="closeModal" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns is-multiline">
            <div class="column is-12">
              <input class="input" type="text" v-model="searchQuery" placeholder="Filtrer par nom ou LLM name">
            </div>
            <div class="column is-12">
              <div>
                <button class="button" @click="sortByName">Trier par Nom</button>
                <button class="button" @click="sortByEloGlobal">Trier par ELO global</button>
              </div>
            </div>
            <div class="column is-12 is-clickable" v-for="assistant in filteredAndSortedAssistants"
                 :key="assistant.name">
              <div
                  class="box"
                  :class="{ 'is-clickable': true, 'selected': selectedAssistant == assistant }"
                  @click="selectedAssistant = assistant"
                  style="box-radius: 4px;"
              >
                <h5>
                  <strong>{{ assistant.name }}</strong>
                </h5>
                <div class="tags">
  <span class="tag">
  ELO:&nbsp;
    <strong v-if="assistant.elo_score">{{ assistant.elo_score }}</strong>
    <strong v-else>pas de partie jouée</strong>
  </span>
                  <span class="tag">{{ assistant.step_set[0].llm_name }}</span>
                  <span class="tag" v-if="assistant.created_by">créé par: {{ assistant.created_by.username }}</span>
                  <span class="tag" v-else>créé par Logos</span>
                  <span class="tag">Température: {{ assistant.step_set[0].temperature }}</span>
                  <span class="tag">
  Stratégie d'exemples:
  {{
                      assistant.step_set[0].example_choice_strategy || assistant.step_set[0].example_selection_strategy || assistant.step_set[0].example_fill_strategy
                    }}
  </span>
                </div>
              </div>
              <!--
              <div class="card" :class="{ 'is-clickable': true, 'selected': selectedAssistant == assistant }" @click="selectedAssistant = assistant">
              <div class="card-content">
              <p class="title">{{ assistant.name }}</p>
              <p>
              {{ assistant.step_set[0].llm_name }} - {{ assistant.step_set[0].temperature }} -
              {{ assistant.step_set[0].example_choice_strategy || assistant.step_set[0].example_selection_strategy || assistant.step_set[0].example_fill_strategy }} -
              {{ assistant.elo_global }}
              </p>
              </div>
              </div>
              -->
            </div>
            <div class="column is-12">
  <textarea
      class="textarea"
      type="text"
      v-model="userInput"
      placeholder="Vous pouvez ici affiner votre demande à l'Assistant: ajouter une information, demander de corriger un élément de la réponse précédente, etc"
  ></textarea>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button btn btn-outline-primary" @click="generate_additional_answer"
                  :disabled="selectedAssistant === null">Générer
          </button>
          <button class="button" @click="closeModal">Annuler</button>
        </footer>
      </div>
    </div>
  </div>

</template>

<script>
import Vue from 'vue'
import settings from '@/settings.coffee'
import ASSISTANTS from '@/gql/queries/assistants.graphql'
import REVIEW_GENERATE_LOGO_ANWSER from '@/gql/mutations/reviewGenerateLogosAnswer.graphql'
import {gqlQuery, gqlMutation} from "@/gqlClient";

export default {
  name: 'LogosAdditionalAnswer',
  props: {
    review: Object,
    answers: Array
  },
  data() {
    return {
      generating: false,
      generation_error: false,
      generation_error_message: null,
      showCard: false,
      showModal: false,
      assistants: [],
      selectedAssistant: null,
      userInput: '',
      searchQuery: '',
      sortKey: '',
    };
  },
  async created() {
    await this.fetchAssistants();
  },
  methods: {
    async fetchAssistants() {
      try {
        const resp = await gqlQuery(ASSISTANTS, {"tags": ["reviews"], "establishment_id": this.review.establishment.uid});
        this.assistants = resp.body.data.assistants.filter(assistant => assistant.is_active);
      } catch (error) {
        console.error('Error fetching assistants:', error);
      }
    },
    generateAdditionalAnswer() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    async generate_additional_answer() {
      const self = this
      this.generating = true;
      this.generation_error = false
      this.generation_error_message = null
      this.closeModal();
      try {
        const resp = await gqlMutation(REVIEW_GENERATE_LOGO_ANWSER, {
          uid: this.review.uid,
          assistant_uid: this.selectedAssistant.uid,
          additional_informations: this.userInput
        })
        if (resp.ok == true) {
          if (resp.body.data.review_generate_logos_answer.ok == false) {
            this.generation_error = true
            if (resp.body.data.review_generate_logos_answer) {
              // everything was ok but the final result is not good
              this.generation_error_message = resp.body.data.review_generate_logos_answer.msg
            } else {
              // answer is ok but the error is here (GraphQL specificity)
              this.generation_error_message = resp.body.errors[0].message
            }
          } else {
            this.$emit('trigger-fetch-review')
            this.$emit('trigger-fetch-answers')
            this.generating = false;
          }
        } else {
          this.generation_error = true
          this.generation_error_message = resp.statusText
        }
        this.generating = false;
      } catch (error) {
        console.log("ERROR generate_additional_answer", error)
        this.generation_error = true
        this.generation_error_message = error.data.review_generate_logos_answer
        this.generating = false;
      }


    },
    sortByName() {
      this.sortKey = 'name';
    },
    sortByEloGlobal() {
      this.sortKey = 'elo_global';
    }
  },
  computed: {
    filteredAndSortedAssistants() {
      let filtered = this.assistants.filter(assistant => {
        return assistant.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
            assistant.step_set[0].llm_name.toLowerCase().includes(this.searchQuery.toLowerCase());
      });

      if (this.sortKey) {
        filtered.sort((a, b) => {
          if (this.sortKey === 'name') {
            return a.name.localeCompare(b.name);
          } else if (this.sortKey === 'elo_global') {
            return b.elo_score - a.elo_score;
          }
          return 0;
        });
      }

      return filtered;
    }
  }
};
</script>

<style scoped>
.selected {
  /* bordure interne verte pastelle */
  border: 2px solid #7c9c9c;
  /* ombre interne */
  box-shadow: inset 0 0 5px rgba(124, 156, 156, 0.5);
}

.columns {
  display: flex;
  justify-content: center;
}

.is-clickable {
  cursor: pointer;
}

.card.selected {
  background-color: #77dd77; /* vert pastelle */
}

.modal-card {
  max-width: 90%;
}
</style>
